import { withJwt } from '../../../utils/with-jwt';
import { miEnvironment } from '../mobile-instructions-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { fromFetch } from 'rxjs/fetch';

/**
 * Deletes a block of instructions
 * @param id The id of the instruction block being deleted
 * @returns Response indicating success and the id of the newly created instruction
 */
export function deleteInstruction(this: unknown, id: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(`${miEnvironment.resolve(this).instructionUrl}/${id}`, {
        method: 'DELETE',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
      })
    )
  ).pipe(ignoreData());
}
